import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkorderService } from 'src/app/services/workorder.service';
import { UtilityService } from 'src/app/services/utility.service';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-canceldeactivate-dialog',
  templateUrl: './canceldeactivate-dialog.component.html',
  styleUrls: ['./canceldeactivate-dialog.component.scss']
})
export class CanceldeactivateDialogComponent implements OnInit {
  reasons: any = [];
  dialogTitle: string = '';
  workorderId: any;
  user: string;
  alertText: string;
  loadReasons: boolean = true;
  compassEnabled: any;
  compassJobId: any;
  className: string = '';
  isCustomUiChange: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CanceldeactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private workorderService: WorkorderService,
    private utilityService: UtilityService,
    private spinner: NgxSpinnerService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.loadReasons = true;
    let status = this.data.dataKey.StatusCode;
    this.className = this.data.panelClass;
    this.isCustomUiChange = this.data.isCustomUiChange;
    this.dialogTitle = this.data.dataKey.DialogTitle;
    this.workorderService.getCancelDeactivateReasons(status).subscribe(res => {
      this.reasons = res;
      this.loadReasons = false;
      this.compassEnabled = localStorage.getItem('compassEnabled');
      this.compassJobId = localStorage.getItem('compassJobId');
    })
  }

  cancelDeactWorkorder(reason: any) {
    this.user = this.userService.dbBBCSId
      ?? (this.utilityService.currentProgramSponsor.SourceId === 'BBCS'
        ? this.utilityService.currentUtility.BBCSUserId || ''
        : localStorage.getItem('loggedInUserName') || '');

    const workorderObj = {
      workorderID: this.data.dataKey.WorkorderID,
      User: this.user,
      Status: this.data.dataKey.StatusCode,
      Reason: reason.ReasonCode,
      UserEmail: "cameron.crochet@honeywell.com",
      CustomerName: "thisUser",
      CustomerAddress: "thisAddress"
    };

    this.alertText =
      this.data.dataKey.StatusCode === 920 ? "Deactivated Successfully" :
        this.data.dataKey.StatusCode === 250 ? "Rejected Successfully" :
          "Cancelled Successfully";

    Swal.fire({
      title: 'Save Changes?',
      text: "Are you sure you want to cancel/deactivate/reject workorder?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save Changes'
    }).then(result => {
      if (result.value) {
        this.spinner.show();
        this.data.dataKey.StatusCode !== 250
          ? this.doCancelDeact(workorderObj)
          : this.returnDeToWorkorder(reason.ReasonCode);
      }
    });
  }

  private doCancelDeact(workorderObj: any) {
    this.workorderService.cancelDeactivateWorkorder(workorderObj).subscribe(res => {
      this.spinner.hide();

      const action = res.Action || "";
      const isCompassEnabled = this.compassEnabled === "1";

      //Error condition without compass
      if (action !== "" && this.compassEnabled === "0") {
        return this.showErrorAndClose(res.Message);
      }

      //Compass enabled — perform extra call
      if (action === "" && isCompassEnabled) {
        return this.handleCompassIntegration();
      }

      //Success normal flow (no compass)
      if (action === "" && (this.compassEnabled === "0" || this.compassEnabled === "undefined")) {
        return this.showSuccessAndClose(this.alertText);
      }
    });
  }

  private handleCompassIntegration() {
    this.workorderService
      .getCompassCancelDeactivateWorkorder(this.data.dataKey.WorkorderID, this.user, this.compassJobId)
      .subscribe(res1 => {

        if (res1.Action) {
          return this.showErrorAndClose("Cancel/Deactivation failed. Reason: " + res1.Message);
        } else {
          return this.showSuccessAndClose(this.alertText);
        }

      });
  }

  private returnDeToWorkorder(reasonCode: any) {
    this.workorderService
      .returnToDEWorkorderService(this.data.dataKey.WorkorderID, reasonCode)
      .subscribe((res: any) => {
        this.spinner.hide();

        if (res.Action === 0) {
          this.showSuccessAndClose("Workorder returned to data entry");
        } else {
          this.showErrorAndClose(res.Message);
        }
      });
  }

  private showSuccessAndClose(message: string) {
    Swal.fire({
      text: message,
      icon: 'success',
      confirmButtonText: 'OK',
    }).then(() => {
      this.dialogRef.close({
        success: true,
        statusCode: this.data.dataKey.StatusCode
      });
    });
  }

  private showErrorAndClose(message: string) {
    Swal.fire({
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
    }).then(() => {
      this.dialogRef.close({ success: false });
    });
  }
}


